/* eslint-disable react/no-array-index-key */
import { FC } from 'react'
import { IconButton, Input, Avatar, Button } from 'rsuite'
import { FaPaperPlane, FaPaperclip } from 'react-icons/fa'
import { MdVideocam, MdClose } from 'react-icons/md'
import './whatsAppTemplate.scss'

interface WhatsappTemplateProps {
  open: boolean;
  selectedTemplate?: any;
  selectedTemplatePreviewData?: any;
  onClose: () => void;
  className?: string;
}

const WhatsappTemplateView: FC<WhatsappTemplateProps> = ({
  open,
  selectedTemplate,
  onClose,
  className,
  selectedTemplatePreviewData
}) => {
  if (!open) return null

  return selectedTemplate ? (
    <div className={`whatsapp-container ${className}`}>
      <div className="chat-header">
        <div className="chat-info">
          <Avatar
            circle
            src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
          />
          <div className="chat-title">
            <h5 className="scrollable-name">Agrobeet</h5>
            <p className="status">Online</p>
          </div>
        </div>
        <div className="chat-actions">
          <IconButton icon={<MdVideocam />} disabled />
          <IconButton icon={<MdClose />} onClick={onClose} />
        </div>
      </div>

      <div className="message-list">
        <div className="message-wrapper">
          {' '}
          <div className="message-item">
            <div className="message-card">
              {' '}
              {selectedTemplate.components &&
                selectedTemplate.components.map(
                  (component: any, index: number) => (
                    <div key={component.id || `component-${index}`}>
                      {component.type === 'HEADER' &&
                        component.format === 'IMAGE' &&
                        component.example?.header_handle?.[0] && (
                          <div className="message-image">
                            <img
                              src={component.example.header_handle[0]}
                              alt="Header"
                            />
                          </div>
                        )}
                    </div>
                  )
                )}
              <div className="message-content">
                {selectedTemplate.components &&
                  selectedTemplate.components.map(
                    (component: any, index: number) => (
                      <div key={component.id || `component-${index}`}>
                        {component.type === 'HEADER' && (
                          <div className="header-message">{component.text}</div>
                        )}
                        {component.type === 'BODY' && (
                          <div className="body-message">{component.text}</div>
                        )}
                      </div>
                    )
                  )}
              </div>
              <div className="message-time">10:45 AM</div>
            </div>
          </div>
        </div>
      </div>

      <div className="message-input">
        <IconButton icon={<FaPaperclip />} disabled />
        <Input placeholder="Type a message" disabled className="input-field" />
        <Button appearance="primary" className="cta-button" disabled>
          <FaPaperPlane />
        </Button>
      </div>
    </div>
  ) : (
    <div className={`whatsapp-container ${className}`}>
      <div className="chat-header">
        <div className="chat-info">
          <Avatar
            circle
            src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
          />
          <div className="chat-title">
            <h5 className="scrollable-name">Agrobeet</h5>
            <p className="status">Online</p>
          </div>
        </div>
        <div className="chat-actions">
          <IconButton icon={<MdVideocam />} disabled />
          <IconButton icon={<MdClose />} onClick={onClose} />
        </div>
      </div>

      <div className="message-list">
        <div className="message-wrapper">
          <div className="message-item">
            <div className="message-card">
              {selectedTemplatePreviewData?.components.map(
                (component: any, index: number) => (
                  <div key={`component-${index}`}>
                    {component.type === 'HEADER' &&
                      component.format === 'IMAGE' &&
                      component.example?.header_handle?.[0] && (
                        <div className="message-image">
                          <img
                            src={component.example.header_handle[0]}
                            alt="Header"
                          />
                        </div>
                      )}
                  </div>
                )
              )}

              <div className="message-content">
                {selectedTemplatePreviewData?.components.map(
                  (component: any, index: number) => (
                    <div key={`component-${index}`}>
                      {component.type === 'HEADER' && (
                        <div className="header-message">{component.text}</div>
                      )}
                      {component.type === 'BODY' && (
                        <div className="body-message">{component.text}</div>
                      )}
                    </div>
                  )
                )}
              </div>
              <div className="message-time">10:45 AM</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default WhatsappTemplateView
